<template>
  <div :class="'body_bm_step bm-form-root '+ ($route.query.view?'look':'')" id="bm-form-root">
    <index-header></index-header>
    <div class="_wrapper">
      <div class="bm_step_box">
        <index-steps :step="3"></index-steps>
        <div class="bm_step_form">
          <a-form :form="form">

            <a-form-item v-if="studentType === 2" label="办理类型" :labelCol="{ span: 12 }" :wrapperCol="{ span: 12 }" :required="true" style="border-bottom:1px solid #ccc;margin:0;padding:10px 0;">
              <a-radio-group  v-model="submitData.student.applyType" @change="onChangeApplyType">
                <a-radio :value="1">材料办理</a-radio>
                <a-radio :value="2">积分办理</a-radio>
              </a-radio-group>
            </a-form-item>

            <div class="form_title" v-if="studentType===1">{{studentType===1?'幼儿报名材料图片上传':'随迁子女报名材料图片上传'}}（仅支持：jpg、jpeg、png、bmp等格式图片上传）</div>
            <div class="form_item" v-if="studentType===1">
              <a-row :gutter="24">

                <a-col :span="8">
                  <a-form-item :label="studentType===1?'幼儿照片':'学生照片'" :label-col="{ span: 10 }" :required="true">
                    <upfile-image v-model="cover_img_1" acceptType="image/jpg, image/jpeg, image/png, image/bmp" :file-size-in-k-b="5000" :handle-success="onUpimageSuccess" :handle-error="imgOnErr1"/>

                      <viewer :images="[cover_img_1]" class="viewer" ref="viewer1" >
                        <template scope="scope">
                          <img v-for="src in scope.images" v-show="false" :src="src" :key="src">
                          <div v-show="!!cover_img_1" style="text-align: center;"><a href="javascript:void(0);" @click="$refs.viewer1.$viewer.show()">预览</a></div>
                        </template>
                      </viewer>

                </a-form-item>
                </a-col>
                <a-col :span="8" v-if="studentType===1">
                  <a-form-item label="户口本首页" :label-col="{ span: 8 }" :required="true">
                    <upfile-image v-model="cover_img_2" acceptType="image/jpg, image/jpeg, image/png, image/bmp" :file-size-in-k-b="5000" :handle-success="onUpimageSuccess" :handle-error="imgOnErr2"/>

                    <viewer :images="[cover_img_2]" class="viewer" ref="viewer2" >
                      <template scope="scope">
                        <img v-for="src in scope.images" v-show="false" :src="src" :key="src">
                        <div v-show="!!cover_img_2" style="text-align: center;"><a href="javascript:void(0);" @click="$refs.viewer2.$viewer.show()">预览</a></div>
                      </template>
                    </viewer>

                  </a-form-item>
                </a-col>
                <a-col :span="8" v-if="studentType===1">
                  <a-form-item label="户口本幼儿页" :label-col="{ span: 8 }" :required="true">
                    <upfile-image v-model="cover_img_3" acceptType="image/jpg, image/jpeg, image/png, image/bmp" :file-size-in-k-b="5000" :handle-success="onUpimageSuccess" :handle-error="imgOnErr3"/>

                    <viewer :images="[cover_img_3]" class="viewer" ref="viewer3" >
                      <template scope="scope">
                        <img v-for="src in scope.images" v-show="false" :src="src" :key="src">
                        <div v-show="!!cover_img_3" style="text-align: center;"><a href="javascript:void(0);" @click="$refs.viewer3.$viewer.show()">预览</a></div>
                      </template>
                    </viewer>
                  </a-form-item>
                </a-col>
              </a-row>
            </div>

            <div class="form_title">{{studentType===1?'幼儿基本信息':'随迁子女基本信息'}}</div>
            <div class="form_item">
              <a-row :gutter="24">
                <a-col :span="8">
                  <a-form-item :label="studentType===1?'幼儿姓名':'学生姓名'" :labelCol="formItemLayout.labelColFirst" :wrapperCol="formItemLayout.wrapperCol" :required="true">
                    <a-input style="width: 200px"
                             size="large" placeholder="不能为空" v-decorator="['submitData.student.name', {
                      validateTrigger: 'blur',
                      rules: [{
                        required: true,
                        message: '姓名不能为空'
                      }]
                    }]"/>
                  </a-form-item>
                </a-col>
                <a-col :span="8">
                  <a-form-item label="性别" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol" :required="true">
                    <a-select size="large" style="width: 200px" placeholder="请选择" v-decorator="['submitData.student.sex', {
                      rules: [{
                        required: true,
                        message: '请选择性别'
                      }]
                    }]">
                      <a-select-option :value="0">男</a-select-option>
                      <a-select-option :value="1">女</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="8">
                  <a-form-item label="民族" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol" :required="true">
                    <a-select size="large" style="width: 200px" placeholder="请选择" v-decorator="['submitData.student.nationName', {
                      rules: [{
                        required: true,
                        message: '请选择民族'
                      }]
                    }]">
                      <a-select-option v-for="item in mingzu" :value="item" >{{item}}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row :gutter="24">
                <a-col :span="8">
                  <a-form-item label="身份证号" :labelCol="formItemLayout.labelColFirst" :wrapperCol="formItemLayout.wrapperCol" :required="true">
                    <a-input style="width: 200px" :disabled="!!this.$route.query.studentSignupId" size="large" placeholder="不能为空" v-decorator="['submitData.student.idCard', {
                      rules: [{
                        required: true,
                        message: '身份证号不能为空'
                      },{
                        pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
                        message: '身份证号格式错误'
                      }]
                    }]" @change="idCardOnChange"/>
                  </a-form-item>
                </a-col>
                <a-col :span="8">
                  <a-form-item label="出生日期" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol">
                    <a-input style="width: 200px" size="large" :disabled="true" v-model="submitData.student.birthday"/>
                  </a-form-item>
                </a-col>

                <!--<a-input style="width: 200px" size="large" hidden v-decorator="['submitData.student.mobile']" v-if="studentType===1"/>-->

                <!--<a-col :span="8" v-show="false">-->
                  <!--<a-form-item label="手机号码" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol">-->
                    <!--<a-input style="width: 200px" size="large" :disabled="true" v-decorator="['submitData.student.mobile']"/>-->
                  <!--</a-form-item>-->
                <!--</a-col>-->
              </a-row>

              <template v-if="studentType===2">
                <a-row :gutter="24">
                  <a-col :span="8">
                    <a-form-item label="申请就读年级" :labelCol="formItemLayout.labelColFirst" :wrapperCol="formItemLayout.wrapperCol">

                      <a-select size="large" style="width: 200px" placeholder="请选择" v-decorator="['submitData.orderGradeName', {
                        rules: [{
                          required: true,
                          message: '请选择'
                        }]
                      }]" @change="orderGradeNameChange">
                        <a-select-opt-group  label="小学">
                          <a-select-option value="一年级">一年级</a-select-option>
                          <a-select-option value="二年级">二年级</a-select-option>
                          <a-select-option value="三年级">三年级</a-select-option>
                          <a-select-option value="四年级">四年级</a-select-option>
                          <a-select-option value="五年级">五年级</a-select-option>
                          <a-select-option value="六年级">六年级</a-select-option>
                        </a-select-opt-group>
                        <a-select-opt-group label="初中">
                          <a-select-option value="七年级">七年级</a-select-option>
                          <a-select-option value="八年级">八年级</a-select-option>
                          <a-select-option value="九年级">九年级</a-select-option>
                        </a-select-opt-group>
                      </a-select>

                    </a-form-item>
                  </a-col>

                  <!--<a-col :span="8">
                    <a-form-item label="原就读年级" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol">
                      <a-select size="large" style="width: 200px" placeholder="请选择" :disabled="submitData.orderGradeName==='一年级'" v-decorator="['submitData.oldGradeName', {
                        rules: [{
                          required: submitData.orderGradeName!=='一年级',
                          message: '请选择'
                        }]
                      }]" @change="oldGradeNameChange">
                        <a-select-opt-group  label="小学">
                          <a-select-option value="一年级">一年级</a-select-option>
                          <a-select-option value="二年级">二年级</a-select-option>
                          <a-select-option value="三年级">三年级</a-select-option>
                          <a-select-option value="四年级">四年级</a-select-option>
                          <a-select-option value="五年级">五年级</a-select-option>
                          <a-select-option value="六年级">六年级</a-select-option>
                        </a-select-opt-group>
                        <a-select-opt-group label="初中">
                          <a-select-option value="七年级">七年级</a-select-option>
                          <a-select-option value="八年级">八年级</a-select-option>
                          <a-select-option value="九年级">九年级</a-select-option>
                        </a-select-opt-group>
                      </a-select>

                    </a-form-item>
                  </a-col>-->

                  <a-col :span="16">
                    <a-form-item label="原就读学校" :labelCol="{span:4}" :wrapperCol="{span:18}">
                      <!--<a-input size="large" style="width: 200px" v-decorator="['submitData.oldSchoolName',{
                      rules: [{
                        required: true,
                        message: '请输入学校'
                      }]
                    }]"/>-->

                      <a-input-group size="large"  compact>
                        <a-select size="large" :disabled="submitData.orderGradeName==='一年级'"  v-model="submitData.containArea" @change="submitData.oldSchoolName=undefined">
                          <a-select-option :value="0">区内</a-select-option>
                          <a-select-option :value="1">区外</a-select-option>
                        </a-select>
                        <a-input v-if="submitData.containArea===1" size="large" placeholder="请输入区外学校名称"  style="width: 400px" :disabled="submitData.orderGradeName==='一年级'" v-model="submitData.oldSchoolName"/>

                        <a-select v-if="submitData.containArea===0" size="large" placeholder="请选择区内学校" style="width: 400px" :disabled="submitData.orderGradeName==='一年级'" v-model="submitData.oldSchoolName">
                          <a-select-option :value="school" v-for="school in areaInSchoolList">{{school}}</a-select-option>
                        </a-select>
                      </a-input-group>

                    </a-form-item>
                  </a-col>

                </a-row>
                <a-row :gutter="24">
                  <a-col :span="24">
                    <a-form-item label="学籍信息" :labelCol="{ span: 3 }" style="padding-left: 10px;">
                      <a-select size="large" style="width: 200px" placeholder="请选择" :disabled="submitData.orderGradeName==='一年级'" v-decorator="['submitData.hasStudentStatus', {
                      rules: [{
                        required: submitData.orderGradeName!=='一年级',
                        message: '请选择'
                      }]
                    }]">
                        <a-select-option :value="0" >无</a-select-option>
                        <a-select-option :value="1" >有</a-select-option>
                      </a-select>
                       <font color="#f76700">（是否有原就读学校签章的学籍信息）</font>
                    </a-form-item>
                  </a-col>
                </a-row>
              </template>
<!--
              <a-row :gutter="24" v-if="studentType===1">

-->
              <a-row :gutter="24">
                <a-col :span="24">
                  <!-- 幼儿园不允许修改，随迁子女允许修改，通过canChangeCount指定 -->
                  <a-form-item :label="studentType===1?'幼儿户籍':'户籍地址'" :labelCol="{ span: 3 }" style="padding-left: 10px;" :required="true">
                    <AreaSelect :provinces="provinces"
                                :lqStreets="lqStreets"
                                class="babySelect"
                                ref="studentArea"
                                :canChangeCount="studentType===1?2:5"
                                :showStreet="studentType===1"
                                :showCommunity="studentType===1"
                                :showDetail="false"
                                v-on:streetChange="onStreetChange"
                                v-on:selectEnd="onCommunityChangeBaby"></AreaSelect>

                  </a-form-item>
                </a-col>
              </a-row>
              <a-row :gutter="24" v-if="studentType===1">
                <a-col :span="24">
                  <a-form-item label="现居住址" :labelCol="{ span: 3 }" style="padding-left: 10px;" :required="true">
                    <AreaSelect :provinces="provinces" :lqStreets="lqStreets" ref="addressArea"></AreaSelect>
                  </a-form-item>
                </a-col>
              </a-row>
            </div>

            <div class="form_title">法定监护人信息（申请人信息）</div>
            <div class="form_item" v-if="studentType===1">
              <a-row :gutter="24">
                <a-col :span="12">
                  <a-form-item
                    :labelCol="formItemLayout.labelColFirst" :wrapperCol="formItemLayout.wrapperCol"
                    label="监护人类型"
                  >
                    <a-radio-group v-decorator="['submitData.guardian.guardianType',{
                      initialValue:1,
                      rules: [{
                        required: true,
                        message: '监护人类型不能为空'
                      }]
                    }]" @change="guardianTypeChange">
                      <a-radio :value="1">
                        法定监护人
                      </a-radio>
                      <a-radio :value="2">
                        委托监护人
                      </a-radio>
                      <!--<a-radio value="3">
                        普通监护人
                      </a-radio>-->
                    </a-radio-group>
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row :gutter="24">
                <a-col :span="8">
                  <a-form-item :label="submitData.guardian.guardianType===2?'委托监护人姓名':'姓名'" :labelCol="formItemLayout.labelColFirst" :wrapperCol="formItemLayout.wrapperCol" :required="true">
                    <a-input style="width: 200px" size="large" placeholder="不能为空" v-decorator="['submitData.guardian.name', {
                      rules: [{
                        required: true,
                        message: '姓名不能为空'
                      }]
                    }]"/>
                  </a-form-item>
                </a-col>
                <a-col :span="8" v-show="false">
                  <a-form-item label="国籍" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol">
                    <a-select size="large" style="width: 200px" placeholder="请选择" v-decorator="['submitData.guardian.countryName', {
                      rules: [{
                        required: false,
                        message: '请选择国籍'
                      }]
                    }]">
                      <a-select-option value="中国">中国</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="8">
                  <a-form-item label="民族" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol" :required="true">
                    <a-select size="large" style="width: 200px" placeholder="请选择" v-decorator="['submitData.guardian.nationName', {
                      rules: [{
                        required: true,
                        message: '请选择民族'
                      }]
                    }]">
                      <a-select-option v-for="item in mingzu" :value="item" >{{item}}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
              </a-row>

              <a-row :gutter="24">
                <a-col :span="8">
                  <a-form-item label="手机号码" :labelCol="formItemLayout.labelColFirst" :wrapperCol="formItemLayout.wrapperCol" :required="true">
                    <a-input style="width: 200px" size="large" placeholder="不能为空" v-decorator="['submitData.guardian.mobile', {
                      rules: [{
                        required: true,
                        message: '手机号码不能为空'
                      },{
                        pattern: /(^1[3|4|5|7|8|9]\d{9}$)|(^09\d{8}$)/,
                        message: '手机号码格式错误'
                      }]
                    }]"/>
                  </a-form-item>
                </a-col>
                <a-col :span="8" v-show="submitData.guardian.guardianType!==2">
                  <a-form-item label="学历" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol" :required="true">
                    <a-select size="large" style="width: 200px" placeholder="请选择" v-decorator="['submitData.guardian.education', {
                      rules: [{
                        required: submitData.guardian.guardianType===1,
                        message: '请选择学历'
                      }]
                    }]">
                      <a-select-option value="小学">小学</a-select-option>
                      <a-select-option value="初中">初中</a-select-option>
                      <a-select-option value="高中">高中</a-select-option>
                      <a-select-option value="专科">专科</a-select-option>
                      <a-select-option value="本科">本科</a-select-option>
                      <a-select-option value="硕士">硕士</a-select-option>
                      <a-select-option value="博士">博士</a-select-option>
                      <a-select-option value="其他">其他</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="8" v-if="submitData.guardian.guardianType===2">
                  <a-form-item label="与幼儿的关系" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol" :required="true">
                    <a-input size="large" placeholder="不能为空" v-decorator="['submitData.guardian.relationship', {
                      rules: [{
                        required: submitData.guardian.guardianType===2,
                        message: '监护人与幼儿的关系'
                      }]
                    }]"/>
                  </a-form-item>
                </a-col>
              </a-row>

              <a-row :gutter="24">
                <a-col :span="24">
                  <a-form-item label="单位" :label-col="{ span: 3 }" :wrapperCol="formItemLayout.wrapperCol" style="padding-left: 10px;" :required="true">
                    <a-input style="width: 550px" size="large" placeholder="不能为空" v-decorator="['submitData.guardian.companyName', {
                      rules: [{
                        required: true,
                        message: '单位不能为空'
                      }]
                    }]"/>
                  </a-form-item>
                </a-col>
              </a-row>

              <a-row :gutter="24">
                <a-col :span="12">
                  <a-form-item :label="submitData.guardian.guardianType===2?'委托人户籍地址':'户籍地址'" :label-col="{ span: 6 }" style="padding-left: 16px;" :required="true">
                    <AreaSelect :provinces="provinces" :lqStreets="lqStreets" :showDetail="false" ref="guardianArea"></AreaSelect>
                  </a-form-item>
                </a-col>
                <!-- <a-col :span="12">
                  <a-form-item :label="submitData.guardian.guardianType===2?'委托人户籍号':'户籍号'" :label-col="{ span: 5 }" style="padding-left: 20px;" :wrapperCol="formItemLayout.wrapperCol" :required="true">
                    <a-input style="width: 150px" size="large" placeholder="数字" v-decorator="['submitData.guardian.houseNumber', {
                      rules: [{
                        required: true,
                        message: '户籍号不能为空'
                      }]
                    }]"/>
                  </a-form-item>
                </a-col> -->
              </a-row>

            </div>

            <div class="form_item" v-if="studentType===2">
              <a-row :gutter="24">
                <a-col :span="8">
                  <a-form-item :label="submitData.guardian.guardianType===2?'委托监护人姓名':'姓名'" :labelCol="formItemLayout.labelColFirst" :wrapperCol="formItemLayout.wrapperCol" :required="true">
                    <a-input style="width: 200px" size="large" placeholder="不能为空" v-decorator="['submitData.guardian.name', {
                      rules: [{
                        required: true,
                        message: '姓名不能为空'
                      }]
                    }]"/>
                  </a-form-item>
                </a-col>
                <a-col :span="8">
                  <a-form-item label="联系方式" :labelCol="formItemLayout.labelColFirst" :wrapperCol="formItemLayout.wrapperCol" :required="true">
                    <a-input style="width: 200px" size="large" placeholder="不能为空" v-decorator="['submitData.guardian.mobile', {
                      rules: [{
                        required: true,
                        message: '手机号码不能为空'
                      },{
                        pattern: /(^1[3|4|5|7|8|9]\d{9}$)|(^09\d{8}$)/,
                        message: '手机号码格式错误'
                      }]
                    }]"/>
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row :gutter="24">
                <a-col :span="8">
                  <a-form-item label="身份证号" :labelCol="formItemLayout.labelColFirst" :wrapperCol="formItemLayout.wrapperCol" :required="true">
                    <a-input style="width: 200px" size="large" placeholder="不能为空" v-decorator="['submitData.guardian.idCard', {
                      rules: [{
                        required: true,
                        message: '身份证号不能为空'
                      },{
                        pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
                        message: '身份证号格式错误'
                      }]
                    }]"/>
                  </a-form-item>
                </a-col>
                <a-col :span="8">
                  <a-form-item label="证件类型" :labelCol="{span:10}" :wrapperCol="formItemLayout.wrapperCol" :required="true">
                    <a-select style="width: 280px" size="large" :disabled="submitData.student.applyType===2" placeholder="请选择" v-decorator="['submitData.guardian.certificateType', {
                      initialValue:submitData.student.applyType===2?1:undefined,
                      rules: [{
                        required: true,
                        message: '请选择类型'
                      }]
                    }]" @change="certificateTypeChange">
                      <a-select-option :value="1">四川省居住证/成都市居住证</a-select-option>
                      <a-select-option :value="2">成都市（非{{areaName}}）户籍居民身份证</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
              </a-row>

              <a-row :gutter="24">
                <a-col :span="24">
                  <a-form-item :label="submitData.guardian.residenceType===3||true?'居住所在地':'居住证所在地'" :labelCol="{ span: 3 }" style="padding-left: 10px;" :required="true">
                    <AreaSelect :provinces="provinces"
                                :lqStreets="lqStreets"
                                ref="guardianArea02"
                                :canChangeCount="2"
                                v-on:streetChange="onStreetChangeName"
                                v-on:selectEnd="onStreetChange02"
                                v-on:villageChange="onCommunityChange"
                                :showStreet="true"
                                :showCommunity="true"
                                :showDetail="true" ></AreaSelect>
                    <p style="padding-left: 12.5%"><font color="#f76700">提示：居住证地址或租赁备案凭证地址</font></p>
                  </a-form-item>
                  <!-- v-on:streetChange="onStreetChange" -->
                </a-col>
              </a-row>

            </div>

            <div class="form_title" v-if="studentType===2">关系证明（申请人及其子女同一户籍的原户籍户口薄或其他能够证明其法定监护关系的有效证明）</div>
            <div class="form_item" v-if="studentType===2">
              <a-row :gutter="24">
                <a-col :span="24">
                  <a-form-item
                    :labelCol="{ span: 1 }" :wrapperCol="{ span: 23 }"
                    label=""
                  >
                    <a-radio-group v-decorator="['submitData.guardian.relationType',{
                      rules: [{
                        required: true,
                        message: '请选择关系证明类型'
                      }]
                    }]">
                      <p style="padding-left: 50px;">
                        <a-radio :value="1">
                          申请人及其子女同一户籍的原籍户口簿
                        </a-radio>
                      </p>
                      <p style="padding-left: 50px;">
                        <a-radio :value="2">
                          子女父母双方的户口簿/结婚证/孩子出生医学证明或亲子鉴定 <font style="color: #f76700">（能够证明其法定监护关系的其他有效证明）</font>
                        </a-radio>
                      </p>
                      <p style="padding-left: 50px;">
                        <a-radio :value="3">
                          申请人的户口簿/被监护人的户口簿/司法部门出具其法定监护关系的证明 <font style="color: #f76700">（能够证明其法定监护关系的其他有效证明）</font>
                        </a-radio>
                      </p>
                    </a-radio-group>
                  </a-form-item>
                </a-col>
              </a-row>
            </div>

            <div class="form_title" v-if="studentType===2 && submitData.student.applyType===1">稳定就业材料</div>
            <div class="form_item" v-if="studentType===2 && submitData.student.applyType===1">
              <a-row :gutter="24">
                <a-col :span="15">
                  <a-form-item
                    :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol"
                    label="类型"
                  >
                    <a-radio-group v-decorator="['submitData.guardian.jobType',{
                      rules: [{
                        required: true,
                        message: '请选择材料类型'
                      }],
                      initialValue:1
                    }]" @change="jobTypeChange">
                      <a-radio :value="1">
                        劳动合同
                      </a-radio>
                      <a-radio :value="2">
                        办理有工商营业执照
                      </a-radio>
                    </a-radio-group>
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row :gutter="24">
                <a-col :span="12" v-if="submitData.guardian.jobType===1">
                  <a-form-item label="劳动合同所在机构" :labelCol="{span:10}" :wrapperCol="{span:12}">
                    <a-input style="width: 200px" size="large" placeholder="输入机构名称"  v-decorator="['submitData.guardian.companyName',{
                      rules: [{
                        required: true,
                        message: '请输入机构'
                      }]
                    }]"/>
                  </a-form-item>
                </a-col>
                <a-col :span="12" v-if="submitData.guardian.jobType===2">
                  <a-form-item label="营业执照/统一社会信用代码" :labelCol="{span:10}" :wrapperCol="{span:12}">
                    <a-input style="width: 200px" size="large"  placeholder="请输入" v-decorator="['submitData.guardian.companyCode',{rules:[
                      {required:true,message:'请输入营业执照/统一社会信用代码'},
                      {max:30,message:'最多30个字符'}
                    ]}]"/>
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row :gutter="24">
                <a-col :span="24">
                  <a-form-item label="社保证明" :labelCol="{ span: 4 }" style="padding-left: 50px;">
                    <a-select size="large" style="width: 200px" placeholder="请选择" v-decorator="['submitData.guardian.socialSecurityProve', {
                      rules: [{
                        required: true,
                        message: '请选择'
                      }]
                    }]">
                      <a-select-option :value="0">无</a-select-option>
                      <a-select-option :value="1">有</a-select-option>
                    </a-select>
                     <font color="#f76700"> （截止2020年5月1日，已在本市连续依法缴纳城镇职工基本养老保险满12个月的清单）</font>
                  </a-form-item>
                </a-col>
              </a-row>
            </div>

            <div class="form_title" v-if="studentType===2&& submitData.student.applyType===1">居住满一年材料（需要在{{areaName}}合法居住连续满一年的材料）</div>
            <div class="form_item" v-if="studentType===2&& submitData.student.applyType===1">
              <a-row :gutter="24">
                <a-col :span="24">
                  <a-form-item
                    :labelCol="{ span: 1 }" :wrapperCol="{ span: 23 }"
                    label=""
                  >
                    <a-radio-group v-decorator="['submitData.guardian.proofType',{
                      rules: [{
                        required: true,
                        message: '请选择'
                      }]
                    }]">
                      <p style="padding-left: 50px;">
                        <a-radio :value="1">
                          有
                        </a-radio>
                        <font color="#f76700">（截止2020年5月1日，申请人已在龙泉驿区连续居住满一年的相关材料）</font>
                      </p>
                      <p style="padding-left: 50px;">
                        <a-radio :value="2">
                          无
                        </a-radio>
                      </p>
                      <!--<p style="padding-left: 50px;">
                        <a-radio :value="3">
                          居住房屋者：提供《房屋租赁登记备案凭证》
                        </a-radio>
                      </p>
                      <p style="padding-left: 50px;">
                        <a-radio :value="4">
                          租住公租房和廉租房者：提供租赁合同
                        </a-radio>
                      </p>
                      <p style="padding-left: 50px;">
                        <a-radio :value="5">
                          居住单位或集体宿舍者：提供该单位集体宿舍的房产证明及单位出具的实际居住证明
                        </a-radio>
                      </p>-->
                    </a-radio-group>
                  </a-form-item>
                </a-col>
              </a-row>
            </div>

            <div class="form_title" v-if="studentType===2 && submitData.student.applyType===2">法定监护人（申请人）的积分信息</div>
            <div class="form_item" v-if="studentType===2 && submitData.student.applyType===2">
              <p>申请人的居住信息，积分达11分及以上（其中缴纳城镇职工基本养老保险得分不低于10分，合法稳定居住指标或累计居住指标不低于1分）</p>
              <a-form-item
                :labelCol="{ span: 2 }" :wrapperCol="{ span: 22 }"
                label="是否符合"
              >
                <a-radio-group v-decorator="['submitData.guardian.accordType',{
                      rules: [{
                        required: true,
                        message: '请选择'
                      }]
                    }]" @change="accordTypeChange">
                  <p style="padding-left: 0px;">
                    <a-radio :value="0">
                      符合
                    </a-radio>
                  </p>
                  <p style="padding-left: 0px;">
                    <a-radio :value="1">
                      不符合
                    </a-radio>
                  </p>
                </a-radio-group>
              </a-form-item>
            </div>

            <div class="form_title" v-if="studentType===1">选择报名幼儿园</div>
            <div class="form_item" style="padding-bottom: 30px;" v-if="studentType===1">
              <a-row :gutter="24">
                <a-col :span="1"></a-col>
                <a-col :span="7" style="border-right: 1px solid #e7e7e7">
                  <div class="school_list">
                    <div style="color: #000; font-size: 16px; padding-bottom: 30px;">
                      <span v-if="!!submitData.student.nativeStreetName">{{submitData.student.nativeStreetName}} <i v-if="!!submitData.student.nativeVillageName">--</i> {{submitData.student.nativeVillageName}}</span>
                      <span v-else>请先选择学生的户籍地址</span>
                    </div>

                    <a-form-item
                      :labelCol="formItemLayout.labelColFirst" :wrapperCol="formItemLayout.wrapperCol"
                      label=""
                    >
                      <a-radio-group v-decorator="['submitData.orderSchoolId',{
                        rules: [{
                          required: true,
                          message: '请选择学校'
                        }]
                      }]" @change="schoolRadioChange">
                        <a-radio style="font-size: 14px;" v-for="(item, index) in schoolList" :value="item.id">{{item.name}}</a-radio>
                        <!--<div style="padding: 6px 10px;" >
                        </div>-->
                      </a-radio-group>
                    </a-form-item>
                  </div>
                </a-col>
                <a-col :span="16">
                  <div class="school_info">{{choiceSchool.introduction || '请选择学校'}}</div>
                </a-col>
              </a-row>
            </div>

            <a-form-item>
              <a-input placeholder="户籍类型，来自上个页面" hidden v-decorator="['submitData.student.houseType']"/>
            </a-form-item>

            <div class="form_title">{{studentType===1?'预约到校审核时间':'预约街道资料审核时间'}}</div>
            <div class="form_item" style="padding-bottom: 30px;">
              <a-row :gutter="24">
                <a-col :span="1"></a-col>
                <a-col :span="13">
                  <div style="color: #000; font-size: 16px; padding-bottom: 20px;" v-if="studentType===1">
                    审核学校：{{choiceSchool.name || '请先选择预约学校'}}
                    <span>{{choiceVillage.name}}</span>
                  </div>
                  <div style="color: #000; font-size: 16px; padding-bottom: 20px;" v-if="studentType===2">
                    审核街道：{{choiceStreet.name || '请先完善上面的居住所在地信息'}}
                  </div>
                  <div style="color: #999; font-size: 16px; font-weight: 100; padding-bottom: 20px; position: relative;" v-if="studentType===1">预约时间：
                    <a-select style="width: 120px; margin-right: 10px;" placeholder="选择年份" @change="onYearChange" v-model="year" :disabled="!choiceSchool.name">
                      <a-select-option :value="item.name" v-for="item in yearList" >{{item.name}}</a-select-option>
                    </a-select>
                    <a-select style="width: 120px; margin-right: 10px;" placeholder="选择月份" @change="onMonthChange" v-model="month" :disabled="!choiceSchool.name">
                      <a-select-option :value="item.name" v-for="item in monthList">{{item.name}}</a-select-option>
                    </a-select>
                    <!--<span style="position: absolute; top: 0; right: 10px;">
                      <a-checkbox @change="onChangeCheckbox" style="color: #35B9BF">只看可预约时间</a-checkbox>
                    </span>-->
                  </div>

                  <div style="color: #999; font-size: 16px; font-weight: 100; padding-bottom: 20px; position: relative;" v-if="studentType===2">预约时间：
                    <a-select style="width: 120px; margin-right: 10px;" placeholder="选择年份" @change="onYearChange" v-model="year" :disabled="!(choiceStreet.name&&yearList.length>0)">
                      <a-select-option :value="item.name" v-for="item in yearList" >{{item.name}}</a-select-option>
                    </a-select>
                    <a-select style="width: 120px; margin-right: 10px;" placeholder="选择月份" @change="onMonthChange" v-model="month" :disabled="!(choiceStreet.name&&yearList.length>0)">
                      <a-select-option :value="item.name" v-for="item in monthList">{{item.name}}</a-select-option>
                    </a-select>
                    <!--<span style="position: absolute; top: 0; right: 10px;">
                      <a-checkbox @change="onChangeCheckbox" style="color: #35B9BF">只看可预约时间</a-checkbox>
                    </span>-->
                  </div>

                  <div style="border: 1px solid #e7e7e7; background: #fafafa;">
                    <a-tabs defaultActiveKey="0" size="small" @change="onPanelChange">
                      <a-tab-pane tab="全部" key="all">
                        <div style="height: 200px; overflow-x: hidden; overflow-y: auto; padding-bottom: 10px;">
                          <!-- <a-row :gutter="24" v-for="subItem in quotaList" :class="subItem.residueNum<=0?(justCanQuota?'none':'zero'):''"> -->
                          <a-row :gutter="24" v-for="subItem in dayQuotaList" :class="subItem.residueNum<=0?'':''">
                            <a-col class="col_item" :span="12">{{subItem.quotaDate}}（周{{getDayByDate(subItem.quotaDate)}}）</a-col>
                            <a-col class="col_item" :span="3">{{['全天','上午','下午'][subItem.amPmType]}}</a-col>
                            <a-col class="col_item" :span="3">余{{subItem.residueNum}}</a-col>
                            <a-col class="col_item" :span="6"><a href="javascript:void(0)" @click="onQuotaClick(subItem)">
                              {{subItem.id===choiceQuota.id?'取消预约':'预约'}}
                            </a></a-col>
                          </a-row>
                        </div>
                      </a-tab-pane>

                      <a-tab-pane v-for="item in dayList" :tab=" (month.length===2?month:'0'+month) + '/'+(item.name.length===2?item.name:'0'+item.name)" :key="item.name">
                        <div style="height: 200px; overflow-x: hidden; overflow-y: auto; padding-bottom: 10px;">
                          <a-row :gutter="24" v-for="subItem in dayQuotaList" :class="subItem.residueNum<=0?'':''">
                          <!-- <a-row :gutter="24" v-for="subItem in dayQuotaList" :class="subItem.residueNum<=0?(justCanQuota?'none':'zero'):''"> -->
                            <a-col class="col_item" :span="12">{{subItem.quotaDate}}（周{{getDayByDate(subItem.quotaDate)}}）</a-col>
                            <a-col class="col_item" :span="3">{{['全天','上午','下午'][subItem.amPmType]}}</a-col>
                            <a-col class="col_item" :span="3">余{{subItem.residueNum}}</a-col>
                            <a-col class="col_item" :span="6"><a href="javascript:void(0)" @click="onQuotaClick(subItem)">
                              {{subItem.id===choiceQuota.id?'取消预约':'预约'}}
                            </a></a-col>
                          </a-row>
                        </div>
                      </a-tab-pane>
                    </a-tabs>
                  </div>
                  <p v-if="!!choiceQuota.quotaDate" style="text-align: center; line-height: 1em; color: #F4C12F; padding-top: 30px;">您的预约时间：{{choiceQuota.quotaDate}} {{choiceQuota.amPmType===2?'下午':'上午'}}</p>
                  <p v-if="!!choiceQuota.quotaDate" style="text-align: center; line-height: 1em;">上午：{{submitData.amBegin||'09:00'}}-{{submitData.amEnd||'12:00'}}  下午{{submitData.pmBegin||'14:00'}}-{{submitData.pmEnd||'17:00'}}</p>
                  <p v-if="!!choiceQuota.quotaDate" style="text-align: center; line-height: 1em; font-size: 16px">温馨提示：请带上相关资料在预约时间到街道进行资料审查</p>
                </a-col>
                <a-col :span="1" style="margin-left: -15px;"></a-col>
                <a-col :span="9" style="border-left: 1px solid #e7e7e7; height: 460px;">
                  <div style="margin-left: 20px;">
                    <h2>审核资料如下</h2>
                    <div style="font-size: 16px; background: #f9f9f9; padding: 20px; height: 420px; overflow-x: hidden; overflow-y: auto; line-height: 30px;" v-if="studentType===2">
                        方式一:用材料办理
                      <br>  1.申请人在有效期内的《居民身份证》和《成都市居住证》或由成都市公安局龙泉驿区公安分局签章的《四川省居住证》（本市户籍只需提供有效期内的《居民身份证》）。（《居住证》需到居住地辖区对应的派出所办理。）
                      <br>  2.申请人及其子女同一户籍的原籍户口簿或其他能够证明其法定监护关系的有效证明（如：①子女父母双方的户口簿、结婚证、孩子出生医学证明或亲子鉴定。②申请人的户口簿、被监护人的户口簿、司法部门出具其法定监护关系的证明）。
                      <br>  3.申请人与龙泉驿区用人单位依法签订有效期内的《劳动合同》或申请人在{{areaName}}办理的工商营业执照（含纳税或免于纳税相关材料）。
                      <br>  4.申请人需提供截止2020年5月1日，已在本市连续依法缴纳城镇职工基本养老保险满12个月的清单（且申请入学当月处于持续缴纳状态）（须打印2019.05-2020.04在成都市连续缴纳12个月的清单；可登陆天府市民云APP、成都市人力资源和社会保障官网、成都人社微信公众号自行打印，也可持本人有效居民身份证原件及社保卡到政务中心办理）。
                      <br>  5.截止2020年5月1日，申请人已在{{areaName}}连续居住满一年的相关材料。（如：以下任一种材料）
                      <br>    ①自购房者：提供房产证明或购房合同，并同时出示有二维码验证标识的《房屋信息查询记录》或《网签合同信息查询记录》（可登陆天府市民云APP、成都数字房产网查询打印记录，也可到龙泉驿区政务中心办理）。
                      <br>    ②居住直系亲属（配偶、子女、父母等）自购房者：提供房产证明和亲属关系证明。
                      <br>    ③租住房屋者：提供《房屋租赁登记备案凭证》（《房屋租赁登记备案凭证》可到居住地所在街道、镇便民服务中心办理）。
                      <br>    ④租住公租房或廉租房者：提供租赁合同。
                      <br>    ⑤居住在单位集体宿舍者：提供该单位集体宿舍的房产证明及单位出具的实际居住证明。
                      <br>  6. 原就读学校签章的学籍信息（小学一年级新生除外）。
                      <br>方式二:用积分办理
                      <br>  1.申请人（积分达11分及以上但未入户的居住证持有人）在有效期内的《居民身份证》和由成都市公安局{{areaName}}公安分局签章的《四川省居住证》。
                      <br>  2.申请人及其子女同一户籍的原籍户口簿或其他能够证明其法定监护关系的有效证明（如：①子女父母双方的户口簿、结婚证、孩子出生医学证明或亲子鉴定。②申请人的户口簿、被监护人的户口簿、司法部门出具其法定监护关系的证明）。
                      <br>  3. 申请人的居住证积分信息。积分达11分及以上，其中缴纳城镇职工基本养老保险得分不低于10分，合法稳定居住指标或累计居住指标不低于1分（居住证积分申请集中受理时间为每年6月1日-7月31日，9月15日起，申请人可登陆成都市居住证积分公众服务平台查询积分结果并打印；居住证积分集中受理地点:{{areaName}}政务服务中心一楼D区,咨询电话：028-96536、028-64733986。请2021年申请子女秋季积分入学的流动人员按要求提前进行积分申报！）。
                      <br>  4.原就读学校签章的学籍信息（小学一年级新生除外）。
                    </div>
                  </div>
                </a-col>
              </a-row>
            </div>

            <a-form-item class="submit_btn" :wrapper-col="formItemLayout.submitWrapperCol" style="padding-top: 50px;">
              <a href="javascript:void(0)" class="sx-btn sx-btn-blue" style="margin-right: 70px;" @click="handleSubmit">提交资料</a>
              <a href="javascript:void(0)" class="sx-btn sx-btn-blue-out" @click="resetInput">重新填写</a>
            </a-form-item>
          </a-form>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import config from '../../../config';
  import IndexHeader from './components/IndexHeader';
  import IndexSteps from './components/IndexSteps';
  import UpfileImage from '../../../sxui/components/upload/UpfileImage';

  import AreaSelect from './components/AreaSelect.vue';

  import axios from 'axios';
  import ARadio from 'ant-design-vue/es/radio/Radio';

  import index_common from './mixins/index_common.js';

  import 'viewerjs/dist/viewer.css';
  import Viewer from 'v-viewer';
  import Vue from 'vue';
  import AButton from 'ant-design-vue/es/button/button';
  import moment from 'moment';

  Vue.use(Viewer);

  const formItemLayout = {
    labelColFirst: { span: 10 },
    labelCol: { span: 8 },
    wrapperCol: { span: 12 },
    submitWrapperCol: { span: 18, offset: 6 }
  };

  export default {
    mixins: [index_common],
    components: {
      AButton,
      ARadio,
      IndexHeader,
      IndexSteps,
      UpfileImage,
      AreaSelect 
    },
    data() {
      return {
        areaName:config.web.areaName,

        // 是否真正提交
        submitIsLoading:false,
        // studentType: 1, // 先写死测试
        form: this.$form.createForm(this),
        formItemLayout,
        // 幼儿园简介
        choiceSchool: {},
        // 中小学选择的街道
        choiceStreet: {
          code: '',
          name: ''
        },
        // 选择的社区
        choiceVillage: {
          code: '',
          name: ''
        },

        // 选中的预约
        choiceQuota: {},

        cover_img_1: '',
        cover_img_2: '',
        cover_img_3: '',

        // 民族列表
        mingzu: ['汉族', '朝鲜族', '满族', '侗族', '瑶族', '白族', '土家族', '哈尼族', '哈萨克族', '傣族', '黎族', '蒙古族', '僳僳族', '佤族', '畲族', '高山族', '拉祜族', '水族', '东乡族', '纳西族', '景颇族', '柯尔克孜族', '回族', '土族', '达斡尔族', '仫佬族', '羌族', '布朗族', '撒拉族', '毛南族', '仡佬族', '锡伯族', '阿昌族', '藏族', '普米族', '塔吉克族', '怒族', '乌孜别克族', '俄罗斯族', '鄂温克族', '德昂族', '保安族', '裕固族', '京族', '维吾尔族', '塔塔尔族', '独龙族', '鄂伦春族', '赫哲族', '门巴族', '珞巴族', '基诺族', '苗族', '彝族', '壮族', '布依族'],

        // 省、市、区、街道 详细列表
        provinces: [],
        // 龙泉驿区街道社区列表
        lqStreets: [],

        // 学校列表
        schoolList: [],
        // 区域内学校列表
        areaInSchoolList: [],

        // 可预约年份
        yearList: [],
        // 可预约月份
        monthList: [],
        // 可预约日期
        dayList: [],

        // 选中的年月日
        year: undefined,
        month: undefined,
        day: '',

        // 一个月总的预约列表
        quotaList: [],
        // 某一天的预约列表
        dayQuotaList: [],
        // 只看可预约
        justCanQuota: false,

        // 临时接到 debug
        tempCommunityName: '',

        // 待提交的数据
        submitData: {
          containArea: 0, // 区内0、区外1
          areaCode: 'string 报名区域Code',
          areaName: 'string 报名区域名称',
          guardian: {
            areaCode: 'string (委托)监护人户籍所属区/县CODE',
            areaName: 'string (委托)监护人户籍所属区/县名称',
            cityCode: 'string (委托)监护人户籍所属州/市/区CODE',
            cityName: 'string (委托)监护人户籍所属州/市/区名称',
            companyCode: '',
            companyName: 'string 工作单位名称',
            countryName: 'string 国籍(幼儿园委托监护人不需要)名称',
            education: '', // string 学历
            guardianType: 1, // "integer 监护人类型：1=法定监护人、2=委托监护人、3=普通监护人(中小学)",
            houseNumber: 'string (委托)监护人户籍号',
            idCard: '',
            mobile: 'string 联系电话',
            name: 'string (委托)监护人姓名',
            nationName: 'string 民族名称',
            proofType: '',
            provinceCode: 'string (委托)监护人户籍所属省份CODE',
            provinceName: 'string (委托)监护人户籍所属省份名称',
            relationType: '',
            relationship: '',
            residenceType: '',
            sex: '',
            socialSecurityProve: '',
            streetId: '',
            villageCode: '',
            villageName: '',
            certificateType: '', // (证件类型: 0=其它、1=四川省居住证/成都市居住证、2=成都市（除龙泉驿区外）户籍居民身份证)
            accordType: '', // (积分信息是否符合: 0=符合、1=不符合)
            jobType: 1 // (稳定就业材料: 0=其它、1=劳动合同、2=办理有工商营业执照)

          },
          hasStudentStatus: '',
          oldGradeName: '',
          oldSchoolName: undefined,
          orderGradeName: '',
          orderSchoolId: 'string 预约学校ID',
          orderSchoolName: 'string 预约学校名称',
          orderStreetCode: 'string 预约街道CODE',
          orderStreetName: 'string 预约街道名称',
          signupNoticeId: 'string 报名通知ID',
          signupQuotaId: 'string 报名名额ID',
          student: {
            applyType: parseInt(this.$route.query.studentApplyType || sessionStorage.getItem('studentApplyType')),
            address: 'string 居住地址',
            areaCode: 'string 所属区/县CODE',
            areaName: 'string 所属区/县名称',
            birthday: 'string 出生日期(后端自动识别)',
            cityCode: 'string 所属州/市/区CODE',
            cityName: 'string 所属州/市/区名称',
            homePage: 'string 户口本首页',
            houseType: '',
            idCard: 'string 身份证号码',
            name: 'string 学生姓名',
            nationName: 'string 民族名称',
            nativeAreaCode: 'string 户籍所在地区/县CODE',
            nativeAreaName: 'string 户籍所在地区/县名称',
            nativeCityCode: 'string 户籍所在地州/市/区CODE',
            nativeCityName: 'string 户籍所在地州/市/区名称',
            nativeProvinceCode: 'string 户籍所在地省份CODE',
            nativeProvinceName: 'string 户籍所在地省份名称',
            nativeStreetCode: 'string 户籍所在地街道CODE',
            nativeStreetName: '', // "string 户籍所在地街道名称",
            nativeVillageCode: '', // 社区
            nativeVillageName: '',
            photo: 'string 幼儿照片/学生照片',
            provinceCode: 'string 所属省份CODE',
            provinceName: 'string 所属省份名称',
            sex: 'integer 性别',
            studentPage: 'string 户口本幼儿页'
          },
          studentSignupId: 'integer 预约号(编辑时必传)',
          studentType: this.studentType
        }

      };
    },
    async mounted() {
      console.log('config',config);
      this.submitData.guardian.certificateType = this.submitData.student.applyType === 2 ? 1 : '';
      this.initPage();
    },
    methods: {
      async initPage() {
        console.log('[-> BmForm] created 用户信息如下::::', '[studentType:]', this.studentType);
        if (this.$route.query.view) {
          let mask = document.createElement('div');
          mask.className = 'look-mask';
          mask.style.height = document.documentElement.clientHeight + 'px';
          document.body.appendChild(mask);
        }

        // 获取省市区街道
        await this.getPcasCodeJson();

        await this.getLQStreetsJson();
        // 获取可预约年月日
        // await this.getYearList();
        // 显示默认的省市区街道
        this.setAreaData();

        let { studentSignupId, idCard, signupNoticeId } = this.$route.query;

        //* ** 情况一：参数接收到已报名的预约号(studentSignupId)和身份证(idCard) 【修改一个报名信息】
        if (studentSignupId && idCard) {
          // 根据报名预约号查询报名信息 #李茹钰/2019-03-14#
          let { data } = await this.$ajax.gateway('/bm/IStudentSignupApi_studentApply', { studentSignupId, idCard });
          if (data.code === 200) {
            console.log('[-> BmForm] [修改] 一个报名信息 todo', data.data);
            sessionStorage.setItem('signupForm', '{"studentName":"' + data.data.student.name + '","idCard":"' + data.data.student.idCard + '"}');
			// 获取区内学校
			await this.getAreaInSchoolList();

            // 回显数据
            this.intStudentApplyData(data.data);
          } else {
            //* ** 情况三：异常
            console.error('-> 根据报名预约号查询报名信息异常，返回登录校验页面');
            this.$router.push({ path: '/index/bm_login', query: { signupNoticeId } })
          }
          //* ** 情况二：参数接收到报名活动的ID(signupNoticeId)，并且通过了前一步的校验(能获取到sessionStorage) 【新增一个报名信息】
        } else {
          try {
            let signupForm = JSON.parse(sessionStorage.getItem('signupForm'));
            if (signupForm && signupNoticeId) {
              console.log('[-> BmForm] [新增] 一个报名信息', signupForm);
              // 此时可根据需要查询报名信息
              // let {data} = await this.$ajax.gateway("/bm/ISignupNoticeApi_getNoticeProtocol", { signupNoticeId});
              // setTimeout(()=>{this.intLocalStorageData(signupForm)},500);
			  // 获取区内学校
			  await this.getAreaInSchoolList();
              this.intLocalStorageData(signupForm);
            } else {
              //* ** 情况三：异常
              console.error('-> 参数或缓存数据异常，返回登录校验页面');
              this.$router.push({ path: '/index/bm_login', query: { signupNoticeId } })
            }
          } catch (e) {
            //* ** 情况三：异常
            console.error('-> 缓存的校验数据异常，返回登录校验页面');
            this.$router.push({ path: '/index/bm_login', query: { signupNoticeId } })
          }
        }

        window.form = this;
      },

      // 回显上一个页面带过来的参数
      intLocalStorageData(info) {
        // 初始化上一个页面前端缓存的数据
        this.form.setFieldsValue({
          // 'submitData.student.mobile':info.guardianMobile,
          'submitData.student.name': info.studentName,
          'submitData.student.idCard': info.idCard
          // 'submitData.guardian.mobile':info.guardianMobile,
        });
        // if(this.studentType===2)
        // this.submitData.student.mobile = info.guardianMobile;
        this.submitData.student.birthday = info.idCard.substring(6, 10) + '-' + info.idCard.substring(10, 12) + '-' + info.idCard.substring(12, 14);
      },

      // 编辑时，将data回显
      intStudentApplyData(data) {
        window.__data = data;
        // 如果设置了reset，只显示上个页面的数据即可，不回显数据
        if (window.localStorage.getItem('reset')) {
          let signupForm = JSON.parse(sessionStorage.getItem('signupForm'));
          this.intLocalStorageData(signupForm);
          // setTimeout(()=>{this.intLocalStorageData(signupForm)},500);
		  // 去除studentApplyType
		  window.sessionStorage.removeItem('studentApplyType');
          return window.localStorage.removeItem('reset');
        }
        // 回显数据
        setTimeout(() => { this.setData(data) }, 500);
      },

      // 获取省市区街道信息，并赋值给provinces
      async getPcasCodeJson() {
        return new Promise(resolve => {
          axios.get(config.publicPath + '/pcas-code.json').then(data => {
            console.log('-> 省市区街道联动 back', data);
            this.provinces = data.data;
            resolve(data.data);
          }).catch(error => {
            this.$message.error('获取省市县街道文件失败！');
            resolve([]);
          });
        })
      },

      // 获取龙泉驿区的街道和社区信息
      async getLQStreetsJson() {
        let { data, error } = await this.$ajax.gateway('/bm/IAreaApi_queryAreas', {
					studentType: this.studentType,
          areaCode: config.web.areaId||'510112'
        });
        console.log('龙泉街道-->', data, error);
        if (error) { return this.$message.error('获取龙泉街道失败！'); }
        this.lqStreets = data.data;
        return data.data;
      },

      /**
       * 获取年月日列表，并存入yearList，依赖监护人的街道码
       * @requires this.submitData.guardian.streetCode
       */
      async getYearList() {
        // 某个区域该次报名的所有可预约的年月日列表（用户填报界面调用） #吴昂/2020-04-14#
        let {data,error} = await this.$ajax.gateway("/bm/ISignupQuotaApi_areaDate", {
            "METHOD": "get",
            "areaCode": this.submitData.guardian.streetCode,
            "signupNoticeId": this.$route.query.signupNoticeId
        });
        // let {data,error} = await this.$ajax.gateway("/bm/ISignupQuotaApi_areaInfoFree", {
        //     "METHOD": "get",
        //     "areaCode": this.submitData.guardian.streetCode,
        //     "noticeId": this.$route.query.signupNoticeId
        // });
        if (error) {
          this.yearList = [];
          return
        }
        console.log('年月日列表', data);
        this.yearList = data.data;
      },

      async getAreaInSchoolList() {

        // 郫都区 区内学校写死
        if(this.studentType===2 && config.web.areaId==='510117'){
          this.areaInSchoolList = [
            `郫都区红光小学校`,
            `郫都区犀浦镇实验学校`,
            `郫都区犀浦外国语学校`,
            `郫都区团结学校`,
            `郫都区古城学校`
          ];
          return;
        }

        // 跟进报名通知ID查询学校列表 #李茹钰/2019-03-28#
        let { data, err } = await this.$ajax.gateway('/bm/ISchoolApi_schoolList', {
          signupNoticeId: this.$route.query.signupNoticeId,
		  studentType: this.studentType
        });
        if (err) return this.$message.error('系统错误！查询区域内学校失败！');
        console.log('区域内学校列表', data);
        // 写死学校
        if (!data.data || data.data.length === 0) { data.data = ['实验小学', '龙泉一小', '龙泉二小', '龙泉三小', '龙泉四小', '龙泉五小', '航天小学', '经开实小', '向阳桥小学', '东山国际小学', '大面小学', '洪河小学', '龙华小学', '土桥小学', '玉石小学', '十陵小学', '和平小学', '青龙湖小学', '灵龙小学', '友谊小学', '同安小学', '洛带小学', '客家小学', '西河小学', '西平小学', '跃进小学', '龙井小学', '天平小学', '洪安小学', '黄土小学', '义和小学', '茶店小学', '山泉小学', '柏合小学', '川大附小（东山）', '北大附小', '川师附小（上东）', '青苗学校', '特教学校']; } else { data.data = data.data.map(item => item.name); }
        this.areaInSchoolList = data.data;
      },

      async getDefaultData() {
        let self = this;

        {
          // 获取街道
          axios.get(config.publicPath + '/pcas-code.json').then(data => {
            console.log('-> 省市区街道联动 back', data);
            this.provinces = data.data;

            let { studentSignupId, idCard, signupNoticeId } = this.$route.query;

            // 【修改一个报名信息】
            if (studentSignupId && idCard) {
              setAreaData();
            } else {
              setTimeout(() => {
 {
              // 51 四川省 5101 成都市 510112 龙泉驿区
                setAreaData();
              }
}, 500);
            }

            function setAreaData() {
              let defaultAreaData = {
                'province': {
                  'code': '51',
                  'name': '四川省'
                },
                'city': {
                  'code': '5101',
                  'name': '成都市'
                },
                'area': {
                  'code': config.web.areaId||'510112',
                  'name': config.web.areaName||'龙泉驿区'
                },
                'street': {
                  'code': '',
                  'name': ''
                },
                'detail': ''
              };
              if (self.studentType === 1) {
                // 幼儿户籍只有街道可以选择
                let studentArea = self.$refs.studentArea;
                studentArea.setData(defaultAreaData);
              }

              if (self.studentType === 2) {
                console.log('set data guardianArea02');
                let guardianArea02 = self.$refs.guardianArea02;
                guardianArea02.setData(defaultAreaData);
              }
            }
          });
        }

        {
          // 根据通知ID查询所有可预约的年月日列表 #李茹钰/2019-03-14#
          let { data, err } = await this.$ajax.gateway('/bm/ISignupQuotaApi_yearMonthDay', {
            signupNoticeId: this.$route.query.signupNoticeId
          });
          if (err) return this.$message.error('系统错误！查询年月日失败！');
          console.log('年月日列表', data);
          this.yearList = data.data;
        }
      },

      // 重新填写
      async resetInput() {
        window.localStorage.setItem('reset', 1);
		window.sessionStorage.setItem('studentApplyType', this.submitData.student.applyType);

        window.location.reload();
        /* this.form.resetFields();
        this.cover_img_1="";
        this.cover_img_2="";
        this.cover_img_3="";
        this.choiceSchool={};
        this.choiceQuota={};
        this.schoolList=[];
        this.quotaList=[];
        this.initPage(); */
      },
      handleSubmit() {
        if(this.submitIsLoading) return console.log('防止二次点击');
        let type1 = this.studentType === 1;
        if (type1) {
          if (!(this.cover_img_1 && this.cover_img_2 && this.cover_img_3)) { return this.$message.error('幼儿报名材料图片尚未上传！'); }
        }

        // if(!type1&&(!this.cover_img_1))
        //  return this.$message.error('随迁子女报名材料图片尚未上传！');

        let studentArea = this.$refs.studentArea && this.$refs.studentArea.getData();
        let addressArea = this.$refs.addressArea && this.$refs.addressArea.getData();
        let guardianArea = this.$refs.guardianArea && this.$refs.guardianArea.getData();
        if (!type1) { guardianArea = this.$refs.guardianArea02 && this.$refs.guardianArea02.getData(); }
        console.log('学生户籍地址-->', studentArea);
        console.log('居住地址-->', addressArea);
        console.log('监护人户籍地址-->', guardianArea);

		// 幼儿园的校验
        if (type1) {
          if (!studentArea.street.code) return this.$message.error('学生户籍地址为必填项，请补充完整！');
          if (studentArea.hasVillages&&!studentArea.village.code) return this.$message.error('学生户籍地址为必填项，请补充完整！');
          if (!addressArea.area.code) return this.$message.error('学生现居地址为必填项，请补充完整！');
          if (!addressArea.detail) return this.$message.error('学生现居地址为必填项，请补充完整！');
          if (!guardianArea.area.code) return this.$message.error('监护人户籍地址为必填项，请补充完整！');
          if (!this.choiceSchool.id) return this.$message.error('请选择审核时间后再提交资料！');
        }

		// 随迁子女的校验
		if (!type1) {
          if (!studentArea.area.code) return this.$message.error('学生户籍地址为必填项，请补充完整！');
          if (this.submitData.orderGradeName !== '一年级' && !this.submitData.oldSchoolName) return this.$message.error('原就读学校为必填项，请补充完整！');
		  let area = type1 ? this.$refs.guardianArea : this.$refs.guardianArea02;
		  let areaData = area.getData();
          if (!areaData.street.code) return this.$message.error('居住地址为必填项，请补充完整！');
		  if (area.hasVillages() && !areaData.village.code) return this.$message.error('居住地址为必填项，请补充完整！');
		}

        if (!this.choiceQuota.id) return this.$message.error('尚未选择预约时间，请选择！');

        let makeParam = () => {
          // 存在时表示编辑
          this.submitData.studentSignupId = this.$route.query.studentSignupId;

          /// 幼儿信息
          this.submitData.student.photo = this.cover_img_1;
          this.submitData.student.homePage = this.cover_img_2;
          this.submitData.student.studentPage = this.cover_img_3;
          this.submitData.student.name = this.form.getFieldValue('submitData.student.name');
          this.submitData.student.sex = this.form.getFieldValue('submitData.student.sex');
          this.submitData.student.nationName = this.form.getFieldValue('submitData.student.nationName');
          this.submitData.student.idCard = this.form.getFieldValue('submitData.student.idCard');
          /* if(type1)
            this.submitData.student.mobile = this.form.getFieldValue('submitData.student.mobile'); */
          // this.submitData.student.birthday = this.form.getFieldValue('submitData.student.birthday');

          // 户籍地址 移到外面来，都有户籍地址
          this.submitData.student.nativeProvinceCode = studentArea.province.code;
          this.submitData.student.nativeProvinceName = studentArea.province.name;
          this.submitData.student.nativeCityCode = studentArea.city.code;
          this.submitData.student.nativeCityName = studentArea.city.name;
          this.submitData.student.nativeAreaCode = studentArea.area.code;
          this.submitData.student.nativeAreaName = studentArea.area.name;
          this.submitData.student.nativeStreetCode = studentArea.street.code;
          this.submitData.student.nativeStreetName = studentArea.street.name;
          this.submitData.student.nativeVillageCode = studentArea.village.code;
          this.submitData.student.nativeVillageName = studentArea.village.name;

          if (type1) {
            // 居住地址
            this.submitData.student.provinceCode = addressArea.province.code;
            this.submitData.student.provinceName = addressArea.province.name;
            this.submitData.student.cityCode = addressArea.city.code;
            this.submitData.student.cityName = addressArea.city.name;
            this.submitData.student.areaCode = addressArea.area.code;
            this.submitData.student.areaName = addressArea.area.name;
            this.submitData.student.address = addressArea.detail;
          }

          // 监护人户籍地址
          this.submitData.guardian.provinceCode = guardianArea.province.code;
          this.submitData.guardian.provinceName = guardianArea.province.name;
          this.submitData.guardian.cityCode = guardianArea.city.code;
          this.submitData.guardian.cityName = guardianArea.city.name;
          this.submitData.guardian.areaCode = guardianArea.area.code;
          this.submitData.guardian.areaName = guardianArea.area.name;
          this.submitData.guardian.address = guardianArea.detail || '';

          // debug
          // this.submitData.student.nativeStreetName = 'debug';

          /// 监护人信息
          this.submitData.guardian.name = this.form.getFieldValue('submitData.guardian.name');
          this.submitData.guardian.countryName = this.form.getFieldValue('submitData.guardian.countryName');
          this.submitData.guardian.nationName = this.form.getFieldValue('submitData.guardian.nationName');
          this.submitData.guardian.mobile = this.form.getFieldValue('submitData.guardian.mobile');
          this.submitData.guardian.education = this.form.getFieldValue('submitData.guardian.education');
          this.submitData.guardian.companyName = this.form.getFieldValue('submitData.guardian.companyName');
          this.submitData.guardian.houseNumber = this.form.getFieldValue('submitData.guardian.houseNumber');
          this.submitData.guardian.guardianType = this.form.getFieldValue('submitData.guardian.guardianType');
          this.submitData.guardian.relationship = this.form.getFieldValue('submitData.guardian.relationship');

          if (!type1) {
            this.submitData.guardian.certificateType = this.form.getFieldValue('submitData.guardian.certificateType');
            this.submitData.guardian.sex = this.form.getFieldValue('submitData.guardian.sex');
            this.submitData.guardian.idCard = this.form.getFieldValue('submitData.guardian.idCard');
            this.submitData.guardian.residenceType = this.form.getFieldValue('submitData.guardian.residenceType');
            this.submitData.guardian.proofType = this.form.getFieldValue('submitData.guardian.proofType');
            this.submitData.guardian.socialSecurityProve = this.form.getFieldValue('submitData.guardian.socialSecurityProve');
            this.submitData.guardian.companyCode = this.form.getFieldValue('submitData.guardian.companyCode');
            this.submitData.guardian.relationType = this.form.getFieldValue('submitData.guardian.relationType');
            this.submitData.guardian.accordType = this.form.getFieldValue('submitData.guardian.accordType');
            this.submitData.hasStudentStatus = this.form.getFieldValue('submitData.hasStudentStatus');
            this.submitData.oldGradeName = this.form.getFieldValue('submitData.oldGradeName');
            // this.submitData.oldSchoolName = this.form.getFieldValue('submitData.oldSchoolName');
            this.submitData.orderGradeName = this.form.getFieldValue('submitData.orderGradeName');
          }

          if (type1) {
            // 预约时选择的学校信息
            this.submitData.orderSchoolId = this.choiceSchool.id;
            this.submitData.orderSchoolName = this.choiceSchool.name;
            this.submitData.orderStreetCode = this.choiceSchool.streetCode;
            this.submitData.orderStreetName = this.choiceSchool.streetName;
            this.submitData.areaCode = this.choiceSchool.areaCode;
            this.submitData.areaName = this.choiceSchool.areaName;
          }

          // 预约时选择的到校时间
          this.submitData.signupQuotaId = this.choiceQuota.id;
          this.submitData.signupNoticeId = this.choiceSchool.signupNoticeId;
          this.submitData.studentType = this.studentType;

          console.log(this.submitData.signupQuotaId, this.submitData.signupNoticeId, this.submitData);
          // console.log('待提交参数-->',JSON.stringify(this.submitData));
        };

        // if(!!this.submitData) return;

        this.form.validateFields(async (err, values) => {
          console.log(values, 333);

          if (err) { return this.$message.error('存在未填写的信息，请补充完整！'); }

          // 非编辑状态需要校验身份证
          if(!this.$route.query.studentSignupId){
            let { error, data } = await this.$ajax.gateway('/bm/IStudentSignupApi_checkIdCard', {
              signupNoticeId: this.$route.query.signupNoticeId,
              idCard: values.submitData.student['idCard']
            });
            console.log('-> 校验学生身份证号码是否已报名', data,error);
            if (!error && data.code === 200) {
              if (data.data) {
                console.log('-> 该学生身份证号码已经报名了', data.data);
                return this.$message.warning('该学生身份证号码已经报过名了！');
              }
            }
            if(error) return;
          }

          if (!err) {
            makeParam();

            if (this.submitData.student.applyType === 2 && this.submitData.guardian.accordType === 1) return this.$message.warn('抱歉，您的积分不符合条件不能进行填报！');
            if (this.submitData.student.applyType === 1 && this.submitData.guardian.socialSecurityProve === 0) return this.$message.warn('抱歉，您的社保不符合条件不能进行填报！');
            // 仅随迁子女做此判断
            if (this.studentType === 2 && !this.submitData.guardian.address.trim()) return this.$message.error('地址详情不能为空！');

            let { signupNoticeId, studentHouseType } = this.$route.query;
            // 添加报名ID
            if (!this.submitData.signupNoticeId && signupNoticeId) this.submitData.signupNoticeId = signupNoticeId;
            // 添加户籍类型
            if (!this.submitData.student.houseType && studentHouseType) this.submitData.student.houseType = studentHouseType;

            this.submitIsLoading=true;
            let { data, error } = await this.$ajax.gateway('/bm/IStudentSignupApi_newProtocol', {
              body: this.submitData
            });
            this.submitIsLoading=false;

            if (data.code === 200) {
              this.$router.push({ path: '/index/bm_info',
query: {
                  signupNoticeId: this.$route.query.signupNoticeId,
                  idCard: this.submitData.student.idCard,
                  studentSignupId: data.data
              } });
            }
          }
        });
      },
      imgOnErr1() {
        this.cover_img_1 = '';
      },
      imgOnErr2() {
        this.cover_img_2 = '';
      },
      imgOnErr3() {
        this.cover_img_3 = '';
      },
      onUpimageSuccess(data) {
        console.log('-> onUpimageSuccess', data);
        if (data[0].attachmentId) this.attachmentId = data[0].attachmentId;
        console.log(this.cover);
      },

      async jobTypeChange(e) {
        this.submitData.guardian.jobType = parseInt(e.target.value);
        console.log(e, 444);
      },
      // 学校的变更事件
      async schoolRadioChange(e) {
        console.log(e.target.value, 444444444);

        let school = {};
        this.schoolList.forEach(item => {
          if (item.id === e.target.value) { school = item; }
        });
        this.choiceSchool = school;
        console.log(this.choiceSchool);

        // 清空预约时间列表
        this.quotaList = [];
        this.year = undefined;
        this.month = undefined;
        this.day = '';
        this.dayList = [];
        // 清空已预约
        this.choiceQuota = {};

        // 查询指定通知的报名名额限制 #李茹钰/2019-03-12#
        /* let data = await this.$ajax.gateway("/bm/ISignupQuotaApi_query", {
          body: {
            quotaDate: "2019-01",
            signupNoticeId: "string 报名通知ID"
          }
        }); */
      },

      // 监护人类型的变化
      guardianTypeChange(e) {
        console.log('变化value --> ', e.target.value);
        this.submitData.guardian.guardianType = parseInt(e.target.value);

        // 切换时清空 ?
        /* this.form.resetFields([
          'submitData.guardian.name',
          'submitData.guardian.idCard',
          'submitData.guardian.mobile',
          'submitData.guardian.nationName',
        ]); */
      },

      onChangeCheckbox(e) {
        this.justCanQuota = e.target.checked;
        console.log(`checked = ${e.target.checked}`)
      },

      onChangeApplyType(e){
        console.log(e.target.value,'办理类型切换');
        //积分办理
        if(e.target.value===2){
          this.form.setFieldsValue({'submitData.guardian.certificateType': 1});
        }

      },

      // 身份证号变更事件
      idCardOnChange(e) {
        // 'submitData.student.idCard'
        console.log(e);
        let cid = e.target.value;
        if (cid.trim().length === 18) { this.submitData.student.birthday = cid.substring(6, 10) + '-' + cid.substring(10, 12) + '-' + cid.substring(12, 14); }
      },

      // 幼儿街道变更事件
      // isEdit 是否编辑时触发
      async onStreetChange(areaData, isEdit) {
        /*console.log(areaData);
        this.submitData.student.nativeStreetName = areaData.street.name;
        this.submitData.student.nativeVillageName = areaData.village.name;
        {
          // 根据街道CODE查询学校列表 #李茹钰/2019-03-12#
          let { data } = await this.$ajax.gateway('/bm/ISchoolApi_searchSchool', {
            signupNoticeId: this.$route.query.signupNoticeId,
            streetCode: areaData.street.code, // debug
            villageCode: areaData.village.code
          });
          this.schoolList = data.data;

          // 选完之后重新赋值，简介字段问题
          if (isEdit) { this.choiceSchool = this.schoolList.filter((item) => { return item.id === this.choiceSchool.id; })[0]; } else {
            this.choiceSchool = {};
            // 清空学校
            this.form.resetFields(['submitData.orderSchoolId']);
          }

          // 清空预约时间列表
          this.quotaList = [];
          this.year = undefined;
          this.month = undefined;
          this.day = '';
          this.dayList = [];
          // 清空已预约
          this.choiceQuota = {};
        }*/


        // 重置名称
        // console.log(areaData);
        this.schoolList = [];
        this.submitData.student.nativeStreetName = areaData.street.name;
        this.submitData.student.nativeVillageName = areaData.village.name;
        // 清空预约时间列表
        this.quotaList = [];
        this.year = undefined;
        this.month = undefined;
        this.day = '';
        this.dayList = [];
        // 清空已预约
        this.choiceQuota = {};
      },
      async onStreetChangeName(areaData, isEdit) {
        console.log(areaData, 2222)
        this.submitData.guardian.streetName = areaData.street.name;
        this.submitData.guardian.streetCode = areaData.street.code;
        this.submitData.guardian.villageCode = areaData.village.code;
        this.submitData.guardian.villageName = areaData.village.name;

        this.choiceStreet.code = areaData.street.code;
        this.choiceStreet.name = areaData.street.name || '';
        this.choiceVillage.code = areaData.village.code;
        this.choiceVillage.name = areaData.village.name || '';
        await this.getYearList();
        // 清空预约时间列表
        this.quotaList = [];
        this.dayQuotaList = []
        this.year = undefined;
        this.month = undefined;
        this.day = '';
        this.dayList = [];
        // 清空已预约
        this.choiceQuota = {};
        console.log('清空预约时间啦');
        // 
      },
      async onStreetChange02(areaData, isEdit) {
        console.log('on select end 选择结束', areaData);
        this.submitData.guardian.streetName = areaData.street.name;
        this.submitData.guardian.streetCode = areaData.street.code;
        this.submitData.guardian.villageCode = areaData.village.code;
        this.submitData.guardian.villageName = areaData.village.name;

        this.choiceStreet.code = areaData.street.code;
        this.choiceStreet.name = areaData.street.name;
        this.choiceVillage.code = areaData.village.code;
        this.choiceVillage.name = areaData.village.name;

        this.submitData.orderStreetCode = areaData.street.code;
        this.submitData.orderStreetName = areaData.street.name;
        this.submitData.areaCode = areaData.area.code;
        this.submitData.areaName = areaData.area.name;

		    // 清空预约时间列表
        this.quotaList = [];
        this.year = undefined;
        this.month = undefined;
        this.day = '';
        this.dayList = [];
        // 清空已预约
        this.choiceQuota = {};
      },
      // 幼儿园社区变更时，调用街道变更的事件
      async onCommunityChangeBaby(areaData,isEdit) {
        console.log(areaData);
        this.submitData.student.nativeStreetName = areaData.street.name;
        this.submitData.student.nativeVillageName = areaData.village.name;
        {
          // 根据街道CODE查询学校列表 #李茹钰/2019-03-12#
          let { data } = await this.$ajax.gateway('/bm/ISchoolApi_searchSchool', {
            signupNoticeId: this.$route.query.signupNoticeId,
            streetCode: areaData.street.code, // debug
            villageCode: areaData.village.code
          });
          this.schoolList = data.data;

          // 选完之后重新赋值，简介字段问题
          if (isEdit) { this.choiceSchool = this.schoolList.filter((item) => { return item.id === this.choiceSchool.id; })[0]; } else {
            this.choiceSchool = {};
            // 清空学校
            this.form.resetFields(['submitData.orderSchoolId']);
          }

          // 清空预约时间列表
          this.quotaList = [];
          this.year = undefined;
          this.month = undefined;
          this.day = '';
          this.dayList = [];
          // 清空已预约
          this.choiceQuota = {};

          // console.log('街道所在的学校-->', this.schoolList,this.choiceSchool,33333333);
          // zxw ?
          // this.choiceSchool = this.schoolList[0];
        }
      },
      onCommunityChange(areaData) {
        this.tempCommunityName = areaData.village.name;
      },

      // 原就读年级变化
      oldGradeNameChange(name) {
        this.submitData.oldGradeName = name;
      },
      // 申请就读年级变化
      orderGradeNameChange(name) {
        console.log(name);
        this.submitData.orderGradeName = name;

        if (name === '一年级') {
          this.submitData.oldSchoolName = undefined;
          this.submitData.oldGradeName = '';
          this.form.resetFields(['submitData.oldSchoolName', 'submitData.oldGradeName', 'submitData.hasStudentStatus']);
        }
      },

      // 居住证类型变化
      certificateTypeChange(type) {
        this.submitData.guardian.certificateType = parseInt(type);
      },

      // 年份的变化
      onYearChange(e) {
        console.log(e);
        this.year = e;
        this.monthList = this.yearList.filter(year => { return year.name === e; })[0].nodes;
      },
      // 月份的变化
      async onMonthChange(e) {
        console.log(this.choiceSchool, 5555555555555);
        /* if(!this.choiceSchool.id)
          return this.$message.error('请先选择学校！'); */
        console.log(e);
        this.month = e;
        this.dayList = this.monthList.filter(month => { return month.name === e; })[0].nodes;

        // 查询指定通知的报名名额限制 #李茹钰/2019-03-12#
        // let { data } = await this.$ajax.gateway('/bm/ISignupQuotaApi_query', {
        //   body: {
        //     day: '',
        //     month: this.month,
        //     signupNoticeId: this.$route.query.signupNoticeId,
        //     schoolId: this.studentType === 1 ? this.choiceSchool.id : '',
        //     streetCode: this.studentType === 2 ? this.choiceStreet.code : '', // 中小学必传
        //     year: this.year
        //   }
        // });
        let {data,error} = await this.$ajax.gateway("/bm/ISignupQuotaApi_areaInfoFree", {
            "METHOD": "get",
            "areaCode": this.choiceStreet.code,
            "noticeId": this.$route.query.signupNoticeId
        });

        this.quotaList = data.data;
        // 跳转到全部一栏
        this.onPanelChange('all');

        // console.log(this.year, this.month, '可预约列表-->', this.quotaList);
      },
      // 积分信息符合变化
      accordTypeChange(e) {
          console.log(e.target.value);
      },
      // 日期的变化
      onPanelChange(key) {
        console.log(key, this.dayQuotaList, this.quotaList);
        this.day = key;

        // 点击某一天的时候
        if (key !== 'all') {
          let date = this.year + '-' + this.month + '-' + this.day;
          this.dayQuotaList = this.quotaList.filter(item => {
            if (item.quotaDate === date) { return item; }
          });
          console.log(this.year, this.month, this.day, '可预约列表-->', this.dayQuotaList);
          return;
        }
        console.log('过滤当前月份');
        // 过滤当前月份
        this.dayQuotaList = this.quotaList.filter(item => {
          // console.log(moment(item.quotaDate).format('YYYY-MM'),moment(this.year+'-'+this.month).format('YYYY-MM'));
          if (moment(item.quotaDate).format('YYYY-MM') === moment(this.year+'-'+this.month).format('YYYY-MM')) { return item; }
        });
        console.log('过滤当前月份',this.dayQuotaList);
      },

      // 预约的点击事件
      onQuotaClick(quota) {
        // if (quota.residueNum <= 0) { return; }
        // 取消预约
        if (!!this.choiceQuota.id && this.choiceQuota.id === quota.id) {
          console.log('取消预约', this.choiceQuota);
          this.choiceQuota = {};
        } else {
          this.choiceQuota = quota;
		  this.submitData.amBegin = quota.amBegin;
		  this.submitData.amEnd = quota.amEnd;
		  this.submitData.pmBegin = quota.pmBegin;
		  this.submitData.pmEnd = quota.pmEnd;
          console.log('预约点击', this.choiceQuota);
        }
      },

      // 根据日期获取星期 2019-03-05 --> 五
      getDayByDate(date) {
        return ['日', '一', '二', '三', '四', '五', '六'][new Date(date).getDay()];
      },

      // 回显 默认的四川省、成都市、龙泉驿区
      // 注：幼儿园、中小学需分开判断，
      setAreaData() {
        let self = this;
        let defaultAreaData = {
          'province': {
            'code': '51',
            'name': '四川省'
          },
          'city': {
            'code': '5101',
            'name': '成都市'
          },
          'area': {
            'code': config.web.areaId||'510112',
            'name': config.web.areaName||'龙泉驿区'
          },
          'street': {
            'code': '',
            'name': ''
          },
          'detail': ''
        };
//        if (self.studentType === 1) {
//          // 幼儿户籍只有街道可以选择
//          let studentArea = self.$refs.studentArea;
//          studentArea.setData(defaultAreaData);
//        }
        let studentArea = self.$refs.studentArea;
        // studentArea.setData(defaultAreaData);

        if (self.studentType === 2) {
          console.log('set data guardianArea02');
          let guardianArea02 = self.$refs.guardianArea02;
          guardianArea02.setData(defaultAreaData);
        }
      },

      // 数据回显，修改时调用
      // data为编辑时的完整数据
      async setData(data) {
        // this.submitData = data;
        let d = { 'areaCode': '510112',
 'areaName': '龙泉驿区',
          'guardian': { 'areaCode': '110101', 'areaName': '东城区', 'cityCode': '1101', 'cityName': '市辖区', 'companyCode': '', 'companyName': '生学教育', 'countryName': '中国', 'education': '1', 'guardianType': '1', 'houseNumber': '123456', 'idCard': '', 'mobile': '18111111111', 'name': '刘备', 'nationName': '汉族', 'proofType': '', 'provinceCode': '11', 'provinceName': '北京市', 'relationType': '', 'relationship': '', 'residenceType': '', 'sex': '', 'socialSecurityProve': '', 'streetId': '' },
'hasStudentStatus': '',
'oldGradeName': '',
'oldSchoolName': undefined,
 'orderGradeName': '',
'orderSchoolId': '1',
'orderSchoolName': '成都市龙泉驿区实验小学校附属幼儿园',
 'orderStreetCode': '510112001',
'orderStreetName': '龙泉街道',
'signupQuotaId': '2',
 'student': { 'address': '', 'areaCode': '110101', 'areaName': '东城区', 'cityCode': '1101', 'cityName': '市辖区', 'homePage': 'http://sxjy-oss-test.oss-cn-hangzhou.aliyuncs.com/res/20190315/9905448843091552643090770.jpg', 'houseType': '', 'idCard': '511111111111111111', 'mobile': '18111111111', 'name': '刘婵', 'nationName': '汉族', 'nativeAreaCode': '110101', 'nativeAreaName': '东城区', 'nativeCityCode': '1101', 'nativeCityName': '市辖区', 'nativeProvinceCode': '11', 'nativeProvinceName': '北京市', 'nativeStreetCode': '110101001', 'nativeStreetName': '东华门街道', 'photo': 'http://sxjy-oss-test.oss-cn-hangzhou.aliyuncs.com/res/20190315/718437499731552643088624.jpg', 'provinceCode': '11', 'provinceName': '北京市', 'sex': '0', 'studentPage': 'http://sxjy-oss-test.oss-cn-hangzhou.aliyuncs.com/res/20190315/7819614596061552643092896.jpg' },
           'studentSignupId': '1',
'studentType': 1 };
        this.submitData = data || d;

        let type1 = this.studentType === 1;

        let studentArea = this.$refs.studentArea;
        let addressArea = this.$refs.addressArea;
        let guardianArea = this.$refs.guardianArea;

        if (!type1) { guardianArea = this.$refs.guardianArea02; }
        console.log('学生户籍地址-->', studentArea);
        console.log('居住地址-->', addressArea);
        console.log('监护人户籍地址-->', guardianArea);

        // 存在时表示编辑
        this.submitData.studentSignupId = this.$route.query.studentSignupId;

        /// 幼儿信息
        this.cover_img_1 = this.submitData.student.photo;
        this.cover_img_2 = this.submitData.student.homePage;
        this.cover_img_3 = this.submitData.student.studentPage;

        this.form.setFieldsValue({
          'submitData.student.name': this.submitData.student.name,
          'submitData.student.sex': this.submitData.student.sex,
          'submitData.student.nationName': this.submitData.student.nationName,
          'submitData.student.idCard': this.submitData.student.idCard,
          'submitData.student.birthday': this.submitData.student.birthday,
          // 'submitData.student.mobile':this.submitData.student.mobile,

          'submitData.guardian.name': this.submitData.guardian.name,
          'submitData.guardian.countryName': this.submitData.guardian.countryName,
          'submitData.guardian.nationName': this.submitData.guardian.nationName,
          'submitData.guardian.mobile': this.submitData.guardian.mobile,
          'submitData.guardian.education': this.submitData.guardian.education,
          'submitData.guardian.companyName': this.submitData.guardian.companyName,
          'submitData.guardian.houseNumber': this.submitData.guardian.houseNumber,
          'submitData.guardian.guardianType': this.submitData.guardian.guardianType,
          'submitData.guardian.relationship': this.submitData.guardian.relationship,

          'submitData.orderSchoolId': this.submitData.orderSchoolId
        });
        console.log('this.submitData.guardian.relationship',this.submitData.guardian.relationship);
        if(type1){
          setTimeout(() => {
            this.form.setFieldsValue({
              'submitData.guardian.relationship': this.submitData.guardian.relationship,
            });
          },500);
        }
        if (!type1) {
          setTimeout(() => {
            this.form.setFieldsValue({
              'submitData.guardian.idCard': this.submitData.guardian.idCard,
              'submitData.guardian.sex': this.submitData.guardian.sex,
              'submitData.guardian.residenceType': this.submitData.guardian.residenceType,
              'submitData.guardian.mobile': this.submitData.guardian.mobile,
              'submitData.guardian.companyCode': this.submitData.guardian.companyCode,
              'submitData.guardian.socialSecurityProve': this.submitData.guardian.socialSecurityProve,
              'submitData.guardian.relationType': this.submitData.guardian.relationType,
              'submitData.guardian.certificateType': this.submitData.guardian.certificateType,
              'submitData.guardian.jobType': this.submitData.guardian.jobType,
              'submitData.guardian.proofType': this.submitData.guardian.proofType,
              'submitData.guardian.companyName': this.submitData.guardian.companyName,
              'submitData.guardian.accordType': this.submitData.guardian.accordType,

              'submitData.oldSchoolName': this.submitData.oldSchoolName,
              'submitData.orderGradeName': this.submitData.orderGradeName,
              'submitData.oldGradeName': this.submitData.oldGradeName,
              'submitData.hasStudentStatus': this.submitData.hasStudentStatus
            });
          }, 500);
        }

        studentArea && studentArea.setData({
          'province': {
            'code': this.submitData.student.nativeProvinceCode,
            'name': this.submitData.student.nativeProvinceName
          },
          'city': {
            'code': this.submitData.student.nativeCityCode,
            'name': this.submitData.student.nativeCityName
          },
          'area': {
            'code': this.submitData.student.nativeAreaCode,
            'name': this.submitData.student.nativeAreaName
          },
          'street': {
            'code': this.submitData.student.nativeStreetCode,
            'name': this.submitData.student.nativeStreetName
          },
          'village': {
            'code': this.submitData.student.nativeVillageCode,
            'name': this.submitData.student.nativeVillageName
          },
          'detail': ''
        });
        addressArea && addressArea.setData({
          'province': {
            'code': this.submitData.student.provinceCode,
            'name': this.submitData.student.provinceName
          },
          'city': {
            'code': this.submitData.student.cityCode,
            'name': this.submitData.student.cityName
          },
          'area': {
            'code': this.submitData.student.areaCode,
            'name': this.submitData.student.areaName
          },
          'street': {
            'code': '',
            'name': ''
          },
          'detail': this.submitData.student.address
        });

        guardianArea.setData({
          'province': {
            'code': this.submitData.guardian.provinceCode,
            'name': this.submitData.guardian.provinceName
          },
          'city': {
            'code': this.submitData.guardian.cityCode,
            'name': this.submitData.guardian.cityName
          },
          'area': {
            'code': this.submitData.guardian.areaCode,
            'name': this.submitData.guardian.areaName
          },
          'street': {
            'code': type1 ? '' : this.submitData.orderStreetCode,
            'name': type1 ? '' : this.submitData.orderStreetName
          },
          'village': {
            'code': type1 ? '' : this.submitData.guardian.villageCode,
            'name': type1 ? '' : this.submitData.guardian.villageName
          },
          'detail': this.submitData.guardian.address
        });

        // 预约时选择的学校信息
        this.choiceSchool.id = this.submitData.orderSchoolId;
        this.choiceSchool.name = this.submitData.orderSchoolName;
        // this.choiceSchool.introduction = this.submitData.orderSchoolName;
        this.choiceSchool.streetCode = this.submitData.orderStreetCode;
        this.choiceSchool.streetName = this.submitData.orderStreetName;
        this.choiceSchool.areaCode = this.submitData.areaCode;
        this.choiceSchool.areaName = this.submitData.areaName;

        if (!type1) {
          console.log('赋值街道。。。。', this.submitData.orderStreetCode, 333);
          this.choiceStreet.code = this.submitData.orderStreetCode;
          this.choiceStreet.name = this.submitData.orderStreetName;
        }

        // 幼儿园数据回显时，回显学校列表
        if (type1) {
          let { data, error } = await this.$ajax.gateway('/bm/ISchoolApi_searchSchool', {
            signupNoticeId: this.$route.query.signupNoticeId,
            villageCode: this.submitData.student.nativeVillageCode,
            streetCode: this.submitData.student.nativeStreetCode
          });
          if (error) return this.$message.error('获取学校失败！' + error);
          this.schoolList = data.data;
          this.choiceSchool = this.schoolList.filter((item) => { return item.id === this.choiceSchool.id; })[0];
          console.log('回显，获取学校列表...', this.schoolList, this.choiceSchool);

          // this.onStreetChange(studentArea.getData(),true);
        }

        // 中小学回显 选中的街道
        if (!type1) {
          let areaData = guardianArea.getData();
          this.submitData.guardian.streetName = areaData.street.name;
          this.submitData.guardian.streetCode = areaData.street.code;
          this.submitData.orderStreetCode = areaData.street.code;
          this.submitData.orderStreetName = areaData.street.name;
          this.submitData.areaCode = areaData.area.code;
          this.submitData.areaName = areaData.area.name;

          this.choiceStreet.code = areaData.street.code;
          this.choiceStreet.name = areaData.street.name;
          // this.onStreetChange02(guardianArea.getData(),true);
        }

        this.studentType = this.submitData.studentType;

        // 回显预约列表及选中的预约
        {
          await this.getYearList();
          this.choiceQuota = this.submitData.signupQuotaDomain;
          let [year, month, day] = this.submitData.signupQuotaDomain.quotaDate.split('-');
          this.year = year;
          this.monthList = this.yearList.filter((item) => { return item.name === year; })[0].nodes;
          this.month = month;
          this.onMonthChange(month);
        }
      }
    }
  };
</script>

<style lang="stylus" scoped>
  .form_title {
    color #175375
    font-size 20px
    line-height 28px
    border-left 10px solid #35B9BF
    padding-left 10px
    font-weight 400
    margin 30px 0 40px;
  }
  .form_item {
    border-bottom 1px solid #e5e5e5
  }
  .school_list {
    height 360px
    overflow-x hidden
    overflow-y auto
  }
  .school_info {
    white-space pre-line
    background #f9f9f9
    margin-left 20px
    padding 20px
    height 360px
    overflow-x hidden
    overflow-y auto
  }
  .col_item {
    text-align center
    line-height 28px
    a {
      color #35B9BF
    }
  }
  .zero{
    color:#ccc;
    a{
      color:#ccc;
    }
  }
  .none{
    display:none;
  }
</style>

<style lang="stylus">
  .bm-form-root.look{
	*{
		cursor:default !important;
	}

    .index_header_page_{
      display:none !important;
    }

    .ant-select-selection,.ant-input{
	  color:#000 !important;
      border:none !important;
      background:none !important;
      outline:none !important;
    }
    .ant-select-arrow,.steps,.ant-form-item-required:before,.submit_btn{
      display:none !important;
    }
    .bm_step_box{
      margin-top:0 !important;
    }
  }

  .look-mask{
    position:fixed;
    left:0;
    top:0;
    width:100%;
  }

  .bm-form-root{
    .babySelect{
      .village{
        width:180px !important;
      }
    }
  }
</style>
